import { Directive, ElementRef, HostListener, Renderer2, Input } from '@angular/core';
import moment from 'moment';
import { ModalController, Events, Platform } from 'ionic-angular';
import { CoEventsRegisterModalPage } from '../../pages/co-events-register-modal/co-events-register-modal';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { AppState } from '../../config/state';
/**
 * Generated class for the CheckRegistrationDirective directive.
 *
 * See https://angular.io/api/core/Directive for more info on Angular
 * Directives.
 */
@Directive({
  selector: '[check-registration]' // Attribute selector
})
export class CheckRegistrationDirective {
  @Input() currentEvent: any;
  canRegister: boolean;
  eventFullWaitListEnabled: boolean = false;
  constructor(public element: ElementRef, public renderer: Renderer2, public state: AppState, public modalCtrl: ModalController, private events:Events, private platform: Platform, private browser: InAppBrowser) {
  }

  ngOnInit() {
    if(this.currentEvent.thirdPartyReg) this.thirdPartyEventCheck(this.currentEvent);
    else this.eventCheck(this.currentEvent);
    this.events.subscribe('updateEventData', (event)=> {
      if (this.currentEvent.eventId === event.eventId){
        if(event.thirdPartyReg) this.thirdPartyEventCheck(event);
        else this.eventCheck(event);
      }
    });
  }

  @HostListener('click', ['$event']) onclick(event) {
    if (this.canRegister) {
      if(this.currentEvent.thirdPartyReg) this.openURL(this.currentEvent.regURL);
      else this.openRegisterModal(this.currentEvent);
    }
  }

  openRegisterModal(event) {
    let modal = this.modalCtrl.create(CoEventsRegisterModalPage, { event: event, joinWaitlist: this.eventFullWaitListEnabled }, {cssClass: 'custom-wide-modal'});
    modal.present();
  }

  openURL(url) {
    if(this.platform.is('cordova')) this.browser.create(url, '_system');
    else window.open(url, '_blank');
  }

  eventCheck(event: any) {
    let reg, icon;
    icon = '<ion-icon name="md-create" role="img" class="icon icon-md ion-md-create item-icon registerIcon" aria-label="create" ng-reflect-name="md-create"></ion-icon>';
    let text = 'REGISTER';

    if (moment().isBefore(event.registrationOpens)) {
      reg = 'Closed';
      this.canRegister = false;
      this.renderer.removeClass(this.element.nativeElement, 'fontColorChange');
    } else if (moment().isBefore(event.registrationCloses) && (!event.registrationOpens || moment().isAfter(event.registrationOpens))) {
      if (event.totalRegistrants >= event.maxAttendees) {
        if (event.allowWaitlist && (event.inPersonWaitlistLeft > 0 || event.virtualWaitlistLeft > 0)) {
          this.eventFullWaitListEnabled = true;
          reg = 'Open';
          text = 'JOIN WAITLIST';
          icon = '<i class="am-waitlist waitlistImg"></i>';
          this.canRegister = true;
        } else {
          reg = 'Closed';
          this.canRegister = false;
          this.renderer.removeClass(this.element.nativeElement, 'fontColorChange');
        }
      } else {
        reg = 'Open';
        this.canRegister = true;
      }
    } else {
      reg = 'Closed';
      this.canRegister = false;
      this.renderer.removeClass(this.element.nativeElement, 'fontColorChange');
    }

    this.stylingAndTextChange(reg, icon, text);
  }

  thirdPartyEventCheck(event) {
    if(this.state.isSelfcheck) return;
    this.canRegister = true;
    let icon = '<ion-icon name="md-open" role="img" class="icon icon-md ion-md-open item-icon registerIcon" aria-label="open" ng-reflect-name="md-open"></ion-icon>';
    this.stylingAndTextChange('Open', icon, 'REGISTER');
  }

  stylingAndTextChange(reg, icon, text) {
    this.element.nativeElement.innerHTML = `${icon}${text}`
    this.renderer.addClass(this.element.nativeElement, `registerButton${reg}`);
    return this.element;
  }

}



// WEBPACK FOOTER //
// ./src/directives/check-registration/check-registration.ts